<template>
    <div class="club-step__navigation">
        <div
            v-for="(step, index) in steps"
            :key="index"
            :class="getClassList(step)"
            @click="goToStep(step)"
        >
            {{ step.title }}
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    name: "Navigation",
    props: {
        activeStep: {
            type: Number,
            default: 0,
        },
    },
    data() {

        const steps = [
            {
                title: "1. My subscription",
                active: false,
                available: true,
            },
            {
                title: "2. My Wines",
                active: false,
                available: true,
            },
            {
                title: "3. Review & Pay",
                active: false,
                available: false
            },
        ].map((step, index) => {
            step.active = index === this.activeStep;
            return step;
        });

        return {
            steps,
        };
    },
    computed: {
        ...mapGetters([
            "getActiveCatalog",
            "getShipmentWines",
        ])
    },
    mounted() {
        this.$nextTick(() => {
            if (this.getActiveCatalog || this.getShipmentWines && this.getShipmentWines[0].ID) {
                this.steps[2].available = true
            }
        })
    },
    methods: {
        ...mapActions(["setConfigStep"]),
        goToStep(step) {
            if (!step.available) return;

            const index = this.steps.indexOf(step);
            this.steps = this.steps.map((s, i) => {
                s.active = false;

                if (i === index) {
                    s.active = true;
                    this.setConfigStep(i);
                }

                return s;
            });
        },
        getClassList(step) {
            const classes = ["club-step__navigation__item"];

            if (step.active) {
                classes.push("active");
            }

            if (step.available) {
                classes.push("available");
            }

            return classes.join(" ");
        },
    },
};
</script>
